var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"id":"alcor-modal-component","visible":_vm.visible,"before-close":_vm.close}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }